__turbopack_context__.v({
  "className": "fontopensans_e7f87e82-module__T1uY6W__className",
  "variable": "fontopensans_e7f87e82-module__T1uY6W__variable",
});
